module.exports = __webpack_public_path__ + "static/image_11_thumb-bc36959fe811bb19fb73dac1a76f5fa1.jpg";